import {APIKeys, AccountAndPreferences, Animals, Cameras, Collars, ConfigurationDevices, DataLoggers, Deployments, DropOffs, ESRIIdentity, ExternalSensors, JSONLogs, ReportIssues, StoredFilters, TT4Sensors, Traps, VirtualFence, Items} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public APIKeys: APIKeys,
    public AccountAndPreferences: AccountAndPreferences,
    public Animals: Animals,
    public Cameras: Cameras,
    public Collars: Collars,
    public ConfigurationDevices: ConfigurationDevices,
    public DataLoggers: DataLoggers,
    public Deployments: Deployments,
    public DropOffs: DropOffs,
    public ESRIIdentity: ESRIIdentity,
    public ExternalSensors: ExternalSensors,
    public JSONLogs: JSONLogs,
    public ReportIssues: ReportIssues,
    public StoredFilters: StoredFilters,
    public TT4Sensors: TT4Sensors,
    public Traps: Traps,
    public VirtualFence: VirtualFence,
    public Items: Items,
  ) {}
}